import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "./productCategory.module.scss";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { FileFromObjectUrl } from "../../../../model/common/file-from-object-url";
import FormWrapper from "../../../../common/components/form-wrapper/FormWrapper";
import CommonFormFieldWrapper, { getFormInputErrors } from "../../../../common/components/form-field-wrapper/CommonFormFieldWrapper";
import CommonFileUploadInput from "../../../../common/components/file-upload-input/CommonFileUploadInput";
import { useCreateProductCategoryMutation, useLazyGetProductCategoriesQuery, useUpdateProductCategoryMutation } from "../../../../service/category-service";
import { ProductCategory } from "../../../../model/appliance";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../../../stores/slices/loader-slice";
import ProductCategoryItem from "./CategoryItem";

type Props = {};

type NewCategory = {
	id: string;
	name: string;
	// power: number;
	// iconEdited: boolean;
	iconUrl: FileFromObjectUrl;
	Image: File;
};

const ProductCategoryPage: React.FC<Props> = (props: Props) => {
	const [search, setSearch] = useState<string>("");
	const [categories, setCategories] = useState<ProductCategory[]>([]);
	const [filteredCategories, setFilteredCategories] = useState<ProductCategory[]>([]);
	const [isFormVisible, setIsFormVisible] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const dispatch = useDispatch();

	const [getProducts, { data, isLoading: fetchLoading, isFetching }] = useLazyGetProductCategoriesQuery();
	const [createCategory, { isLoading }] = useCreateProductCategoryMutation();
    const [editCaetgory, { isLoading: editLoading}] = useUpdateProductCategoryMutation()
	const handleGetAppliance = () => {
		dispatch(showLoader());
		getProducts()
			.unwrap()
			.then(res => {
				setCategories(res?.categories);
				setFilteredCategories(res?.categories);
			})
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

    useEffect(()=>{
      if(data?.categories){
        setCategories(data.categories);
        setFilteredCategories(data.categories);
      }
    },[data])

	useEffect(() => {
		handleGetAppliance();
	}, []);

	useEffect(() => {
		const filtered = categories.filter(category => category.name.toLowerCase().includes(search.toLowerCase()));
		setFilteredCategories(filtered);
	}, [search, categories]);

	const addNewCategory = () => {
		const formData = new FormData();
		const obj = getValues();
		formData.append("Name", obj.name.trim());

		formData.append("Image", obj.Image);


		dispatch(showLoader());
		createCategory(formData)
			.unwrap()
			.then(res => {
				toast.success("Category added successfully");
				cancelForm();
			})
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

    const handleEditCategory = () =>{
        const formData = new FormData();
		const obj = getValues();
        
        formData.append("Id", obj.id);
		formData.append("Name", obj.name.trim());
        if(obj.Image){
		formData.append("Image", obj.Image);
        }


		editCaetgory(formData)
			.unwrap()
			.then(res => {
				toast.success("Category edited successfully");
				cancelForm();
			})
			.catch(err => toast.error(err?.data?.title as string))
			// .finally(() => dispatch(hideLoader()));
    }

	const editCategory = async (category: ProductCategory) => {
		setIsEdit(true);
		setIsFormVisible(true);
		reset({
			id: category.id,
			name: category.name,
			// iconEdited: false,
			iconUrl: {
				url: category.imageUrl,
				name: category.imageUrl.split("/").pop()!,
			},
		});
	};

	function containsSearch() {
		if (search) {
			return styles.searchContainesText;
		}
	}

	function changeSearch(e: React.ChangeEvent<HTMLInputElement>) {
		setSearch(e.target.value.trim());
	}

	const onFilesSelection = (files: File[]) => {
		if (files.length === 0) {
			return;
		}

		const fileToSend: FileFromObjectUrl = {
			name: files[0].name,
			url: URL.createObjectURL(files[0]),
		};
		setValue("Image", files[0]);
		setValue("iconUrl", fileToSend, { shouldValidate: true, shouldTouch: true, shouldDirty: true });
		// setValue("iconEdited", true);
	};

	const {
		register,
		watch,
		formState: { errors, isValid },
		setValue,
		getValues,
		reset,
	} = useForm<NewCategory>({
		defaultValues: {
			name: undefined,
			Image: undefined,
			iconUrl: {
				name: "",
				url: "",
			},
		},
		reValidateMode: "onSubmit",
		mode: "onTouched",
	});

	const cancelForm = () => {
		setIsFormVisible(false);
		reset();
	};

	const openNewForm = () => {
		setIsEdit(false);
		reset({
			name: "",
			Image: undefined,
			// iconEdited: false,
			iconUrl: undefined,
		});
		setIsFormVisible(true);
	};

	return (
		<div className={styles.container}>
			<div className={styles.leftSide}>
				<FormWrapper titleSection={{ title: "All Categories", subtitle: "", buttonTitle: "Add" }} onSaveAndContinue={openNewForm}>
					<div className={styles.findApplianceContainer}>
						<div className={`${styles.searchContainer} ${containsSearch()}`}>
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M15.2825 14.7176L12.5001 11.9576C13.5801 10.6109 14.1032 8.90152 13.9617 7.18103C13.8201 5.46053 13.0248 3.85964 11.7392 2.70753C10.4536 1.55543 8.77541 0.939683 7.04974 0.986903C5.32408 1.03412 3.68209 1.74072 2.46141 2.96141C1.24072 4.18209 0.534124 5.82408 0.486903 7.54974C0.439683 9.27541 1.05543 10.9536 2.20753 12.2392C3.35964 13.5248 4.96053 14.3201 6.68103 14.4617C8.40152 14.6032 10.1109 14.0801 11.4576 13.0001L14.2176 15.7601C14.2873 15.8303 14.3702 15.8861 14.4616 15.9242C14.553 15.9623 14.651 15.9819 14.7501 15.9819C14.8491 15.9819 14.9471 15.9623 15.0385 15.9242C15.1299 15.8861 15.2128 15.8303 15.2825 15.7601C15.4177 15.6202 15.4933 15.4333 15.4933 15.2388C15.4933 15.0443 15.4177 14.8574 15.2825 14.7176ZM7.25005 13.0001C6.2117 13.0001 5.19666 12.6921 4.33331 12.1153C3.46995 11.5384 2.79704 10.7185 2.39968 9.75914C2.00232 8.79983 1.89836 7.74423 2.10093 6.72583C2.3035 5.70743 2.80351 4.77197 3.53774 4.03774C4.27197 3.30351 5.20743 2.8035 6.22583 2.60093C7.24423 2.39836 8.29983 2.50232 9.25914 2.89968C10.2185 3.29704 11.0384 3.96995 11.6153 4.83331C12.1921 5.69666 12.5001 6.7117 12.5001 7.75005C12.5001 9.14244 11.9469 10.4778 10.9624 11.4624C9.97779 12.4469 8.64244 13.0001 7.25005 13.0001Z"
									fill="#2E3336"
								/>
							</svg>
							<input placeholder="Search categories" onChange={changeSearch} />
						</div>
						<div className={styles.searchResultContainer}>
                            {isFetching && <div>Updating list...</div>}
							{filteredCategories?.map((category, index) => (
								<ProductCategoryItem category={category} key={index} isAdded onEditApplianceHandler={() => editCategory(category)} />
								// <SearchResultItem
								// 	key={appliance.id}
								// 	appliance={appliance}
								// 	isAdded
								// 	onEditApplianceHandler={() => editAppliance(appliance)}
								// 	onDeleteApplianceHandler={() => deleteAppliance(appliance)}
								// />
							))}
						</div>
					</div>
				</FormWrapper>
			</div>
			{isFormVisible && (
				<div className={styles.rightSide}>
					<FormWrapper
						titleSection={{ title: isEdit ? "Edit appliance" : "Create new Category", subtitle: "", buttonTitle: "Save Changes" }}
						onBack={cancelForm}
						isNotValid={!isValid || isLoading || editLoading}
						onSaveAndContinue={() => (!isEdit ? addNewCategory() : handleEditCategory())}
					>
						<div className={styles.formSection}>
							<CommonFormFieldWrapper title="Category Name" required errors={getFormInputErrors(errors.name?.message)}>
								<input {...register("name", { required: "Category name" })} placeholder="Enter Category Name" type="text" />
							</CommonFormFieldWrapper>

							<CommonFormFieldWrapper title="Category Image" required errors={getFormInputErrors(errors.iconUrl?.message)}>
								<div className={styles.fileInputContainer}>
									<CommonFileUploadInput
										maxFileSize={24}
										initialFiles={[watch("iconUrl.name")]}
										accept="image/*"
										registerInputProps={register("iconUrl", { required: "Appliance Image is required" })}
										onFilesSelect={onFilesSelection}
									/>
								</div>
							</CommonFormFieldWrapper>
						</div>
					</FormWrapper>
				</div>
			)}
		</div>
	);
};

export default ProductCategoryPage;
